import { render, staticRenderFns } from "./SerialList.vue?vue&type=template&id=4843a38c&"
import script from "./SerialList.vue?vue&type=script&lang=js&"
export * from "./SerialList.vue?vue&type=script&lang=js&"
import style0 from "./SerialList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports